import styled from "styled-components";

export const AdVideoWrapper = styled.div<{ hasList: boolean }>`
  position: absolute;
  z-index: 1000;
  width: calc(1920px - 60px);
  height: calc(1080px - 70px);
  top: 0;
  left: 0;
  background: ${(p) => (p.hasList ? "#0E0D2B" : "tranfrom")};
  padding: 40px 30px 30px;
  display: flex;
  flex-direction: column;

  > video {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
  }
  video::-webkit-media-controls-fullscreen-button {
    display: none !important;
  }
`;

export const AdVideoHeaderWrapper = styled.div`
  padding: 16px 20px;
  width: calc(100% - 40px);
  height: 80px;
  border-radius: 14px;
  border: 0.889px solid #17b9ff;
  background: radial-gradient(
    97.26% 92.59% at 17.58% 4.3%,
    rgba(46, 167, 255, 0.5) 0%,
    #1c1b33 78.06%
  );

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const AdVideoHeaderLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;

  > img {
    width: 80px;
    height: 80px;
    border-radius: 80px;
    object-fit: cover;
  }

  > .title {
    color: #fff;
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .sub-title {
    color: #fff;
    font-family: Pretendard;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const AdVideoHeaderRightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  color: #fff;
  text-align: right;
  font-family: Pretendard;
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const AdVideoBodyWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const AdVideoBodyLeftWrapper = styled.div`
  width: 1335px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const AdVideoBodyVideoWrapper = styled.div`
  width: 1335px;
  height: 700px;

  position: relative;

  > video {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    object-fit: cover;
    border-radius: 14px;
  }
`;

export const AdVideoBodyLeftBottomWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const AdVideoBodyLeftBottomItemWrapper = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;

  border-radius: 14px;
  border: 1px solid var(--Outline-Container-2, rgba(23, 185, 255, 0.1));
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(76, 39, 139, 0.8) 0%,
    rgba(28, 27, 51, 0.2) 78.06%
  );

  > .title {
    margin-left: 30px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 23px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    margin-left: 30px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .sub-value {
    margin-left: 30px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const AdVideoBodyVideoTimeBox = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 64px;
  border-radius: 14px 14px 0 0;
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(255, 0, 4, 0.73) 0%,
    rgba(255, 4, 8, 0.47) 78.06%
  );

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  color: #fff;
  font-family: "Termina Test";
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const AdVideoBodyRightWrapper = styled.div`
  flex: 1;
  height: 100%;

  border-radius: 14px;
  border: 0.986px solid var(--Outline-Container-2, rgba(23, 185, 255, 0.1));
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(76, 39, 139, 0.8) 0%,
    rgba(28, 27, 51, 0.2) 78.06%
  );

  > .inner-wrapper {
    width: calc(100% - 56px);
    height: calc(100% - 68px);

    padding: 28px 28px 40px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    position: relative;
  }
`;

export const AdVideoNoticeBox = styled.div`
  position: absolute;
  bottom: 41px;
  left: 28px;
  width: calc(100% - 80px);
  height: 113px;
  box-sizing: border-box;

  padding: 12px;
  border-radius: 16px;
  border: 0.986px solid rgba(23, 185, 255, 0.1);
  background: radial-gradient(
    72.87% 114.83% at 17.58% 4.3%,
    rgba(255, 0, 4, 0.4) 0%,
    rgba(255, 4, 8, 0.16) 78.06%
  );
  color: #fff;
  font-family: "Termina Test";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.15;

  overflow: hidden;
  word-break: break-word;
`;

export const AdVideoBodyRightTitle = styled.div`
  color: #fff;
  font-family: "Termina Test";
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const AdVideoBodyRightListWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4.93px;
`;

export const AdVideoPrizeListItem = styled.div`
  width: 100%;
  height: 59px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .rank {
    width: 102px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    > span {
      color: #fff;
      font-family: "Termina Test";
      font-size: 22px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;

export const AdVideoPrizeListItemInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  > .prize {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    > span {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }

  > .sub-prize {
    padding: 6px 14px;
    border-radius: 10px;
    background: #002f68;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .chip {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
